// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 335,
      y: 432,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '95d277a4-48d9-4457-89db-a8b0faa57854',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.233553
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Pop_Up_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        game: {
          scale: {
            y: 1.17
          },
          y: -18
        }
      }
    },
    {
      id: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: -11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        game: {
          scale: {
            y: 1.2,
            x: 1.2
          },
          y: 30
        }
      }
    },
    {
      id: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      type: 'Sprite',
      name: 'header',
      className: '',
      x: 0,
      y: -331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Header',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '69551968-9529-4083-9063-7d6a04eee1ba',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 266,
      y: -320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -73,
        y: -75,
        width: 140,
        height: 144
      },
      texture: 'Close_Button',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '8182aa72-d621-4dc6-b74b-cf632363e4de',
      type: 'Container',
      name: 'buyLivesGroup',
      className: '',
      x: -1,
      y: 127,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        game: {
          y: 190
        }
      }
    },
    {
      id: '30d68f9f-c05a-4d9f-a88f-ae1504d97252',
      type: 'Container',
      name: 'askForLivesGroup',
      className: '',
      x: -1,
      y: 247,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        game: {
          visible: false
        }
      }
    },
    {
      id: '2cb0246c-1dba-4fdc-9faf-a6b294e614c2',
      type: 'Sprite',
      name: 'bgHexagon',
      className: '',
      x: 1,
      y: -82,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Hexagone_Field',
      parent: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      stateByName: {
        game: {
          scale: {
            y: 1.38
          }
        }
      }
    },
    {
      id: 'c6db44fa-dced-4972-9ddf-9bc2af3705b3',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: -6,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.45,
        y: 0.45
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      stateByName: {
        game: {
          y: -116,
          x: 0,
          scale: {
            x: 0.4,
            y: 0.4
          }
        }
      }
    },
    {
      id: '2e765838-acb4-4eb2-beba-7b0cf4ed3c58',
      type: 'Sprite',
      name: 'bigHeart',
      className: '',
      x: -2,
      y: -90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Heart',
      parent: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      stateByName: {
        game: {
          y: -116,
          x: 0,
          texture: 'Broken_Heart_Icon'
        },
        'main-menu-max-lives': {
          texture: 'Big_Heart'
        },
        'main-menu': {
          texture: 'Big_Heart'
        }
      }
    },
    {
      id: 'ae8f8024-c22b-4a1a-90a4-4c652b4c7dca',
      type: 'Text',
      name: 'livesCountdownText',
      className: '',
      x: 0,
      y: 34,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Next Life In:\\n00:10:00',
      localize: false,
      maxWidth: 367,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#e84302',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 250,
        breakWords: false,
        lineHeight: 28,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7f863a7e-000c-41d2-9f3a-09381c2f227f',
      stateByName: {
        game: {
          maxWidth: 300,
          y: 20,
          style: {
            fontSize: 34,
            lineHeight: 33,
            fill: 'white',
            stroke: '#e84302',
            strokeThickness: 7,
            fontFamily: 'Baloo{wf}',
            padding: 0,
            wordWrap: true,
            wordWrapWidth: 250,
            align: 'center',
            dropShadow: false,
            dropShadowAlpha: 1,
            fillGradientType: 0,
            fillGradientStops: '',
            fontVariant: 'normal',
            whiteSpace: 'pre',
            lineJoin: 'round',
            baseline: 'alphabetic',
            fontStyle: 'normal',
            letterSpacing: 0,
            leading: 0,
            trim: false,
            miterLimit: 10,
            breakWords: false,
            fontWeight: 'lighter',
            dropShadowDistance: 5,
            dropShadowColor: 'black',
            dropShadowBlur: 0,
            dropShadowAngle: 0
          }
        },
        'main-menu': {
          maxWidth: 300
        },
        'main-menu-max-lives': {
          style: {
            wordWrap: true,
            wordWrapWidth: 250,
            stroke: '#e84302',
            fill: 'white',
            fontSize: 28,
            strokeThickness: 7,
            fontFamily: 'Baloo{wf}',
            padding: 0,
            align: 'center',
            dropShadow: false
          },
          text: 'Maximum amount of lives',
          localize: true
        }
      }
    },
    {
      id: '6110fb58-4e31-43e0-b59e-22367159183d',
      type: 'Text',
      name: 'title',
      className: '',
      x: -3,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lives',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      stateByName: {
        game: {
          text: 'Out of Lives'
        }
      }
    },
    {
      id: 'd1f00993-a1b3-4390-b34b-34b370380426',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 181,
        y: 70
      },
      width: 362,
      height: 139,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: '8182aa72-d621-4dc6-b74b-cf632363e4de'
    },
    {
      id: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      type: 'Container',
      name: 'livesButtonContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '8182aa72-d621-4dc6-b74b-cf632363e4de',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'a495170e-c831-4b44-bf8a-1332d64c650e',
      type: 'Container',
      name: 'askForLivesButton',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '30d68f9f-c05a-4d9f-a88f-ae1504d97252'
    },
    {
      id: '6777addb-0f5a-46b7-97b9-7204c06df76d',
      type: 'Layout',
      name: 'buyLivesButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      data: {
        color: 'yellow'
      },
      stateByName: {
        'main-menu': {
          visible: true
        },
        'main-menu-max-lives': {
          visible: false
        }
      }
    },
    {
      id: '04b8c0e6-d8cf-4990-99ba-484ebb0e1e3b',
      type: 'Layout',
      name: 'maxLivesButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      data: {
        color: 'grey'
      },
      stateByName: {
        'main-menu': {
          visible: false
        },
        'main-menu-max-lives': {
          visible: true
        }
      }
    },
    {
      id: '234d0f96-06c5-44f3-b2e5-bc716b193d8b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 45,
      y: -25,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Field',
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          visible: false
        },
        'main-menu': {
          visible: true
        }
      }
    },
    {
      id: 'aaa78cca-7ae6-41e1-8e97-d507170c6d4f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 31,
      y: -27,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin',
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          visible: false
        },
        'main-menu': {
          visible: true
        }
      }
    },
    {
      id: 'd8f41219-77cc-41f6-82db-a39d94e50c25',
      type: 'Text',
      name: 'buyLivesCoinAmountText',
      className: '',
      x: 80,
      y: -6,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '999',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#e84302',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          visible: false
        },
        'main-menu': {
          visible: true
        }
      }
    },
    {
      id: 'ad8a1ffa-cf77-431d-aa09-d400be3a90b5',
      type: 'Text',
      name: 'buyLivesAmountText',
      className: '',
      x: -68,
      y: -1,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#e84302',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          visible: false
        },
        'main-menu': {
          visible: true
        }
      }
    },
    {
      id: '178c6d25-65a5-4d39-b060-5a95be7b21aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: -133,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Icon',
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          texture: 'Heart_Icon'
        },
        'main-menu': {
          visible: true,
          texture: 'Heart_Icon'
        },
        game: {
          texture: 'Heart_Icon'
        }
      }
    },
    {
      id: '607092df-bdd7-4a51-b8b5-399a7caf02b8',
      type: 'Text',
      name: 'buyLivesMaxText',
      className: '',
      x: 12,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Max',
      localize: true,
      maxWidth: 180,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#e84302',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'efe4ea2a-eb85-405c-b751-e474d8771bb5',
      stateByName: {
        'main-menu-max-lives': {
          visible: true,
          style: {
            padding: 0
          }
        },
        'main-menu': {
          visible: false
        }
      }
    },
    {
      id: '53b254b4-28a7-4230-a8f8-5bca7a1f8682',
      type: 'Layout',
      name: 'askFriendReadyGroup',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'a495170e-c831-4b44-bf8a-1332d64c650e',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '798026a3-fd4b-4f52-8954-14f41df2a205',
      type: 'Layout',
      name: 'askFriendCooldownGroup',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: true,
      parent: 'a495170e-c831-4b44-bf8a-1332d64c650e',
      data: {
        color: 'grey',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '71e0f4f2-90aa-41c3-8a09-1dc272276d53',
      type: 'Text',
      name: '',
      className: '',
      x: 38,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Ask a friend',
      localize: true,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1f70f2',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '53b254b4-28a7-4230-a8f8-5bca7a1f8682'
    },
    {
      id: '21cd66c2-27d2-41fa-a593-70ca97fc50b9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -134,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Icon',
      parent: '53b254b4-28a7-4230-a8f8-5bca7a1f8682',
      stateByName: {
        'main-menu-max-lives': {
          texture: 'Heart_Icon'
        },
        'main-menu': {
          texture: 'Heart_Icon',
          scale: {
            x: 0.75,
            y: 0.75
          }
        }
      }
    },
    {
      id: 'ad6ec340-3745-4908-babe-da468ddd3644',
      type: 'Text',
      name: '',
      className: '',
      x: -89,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+1',
      localize: false,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1f70f2',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '53b254b4-28a7-4230-a8f8-5bca7a1f8682',
      stateByName: {
        'main-menu': {
          style: {
            stroke: '#1f70f2'
          }
        }
      }
    },
    {
      id: '24fad317-fe0d-4ea4-9c5a-76b5b11de7b4',
      type: 'Text',
      name: '',
      className: '',
      x: 33,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Ask a friend',
      localize: true,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#555555',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '798026a3-fd4b-4f52-8954-14f41df2a205'
    },
    {
      id: '112fe10b-0881-4db9-a571-345a66f2f4eb',
      type: 'Text',
      name: 'askFriendCountdownText',
      className: '',
      x: 31,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ready in 30:00',
      localize: false,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#555555',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '798026a3-fd4b-4f52-8954-14f41df2a205',
      stateByName: {
        'main-menu': {
          style: {
            fill: 'white'
          }
        }
      }
    },
    {
      id: 'ef9b952f-92f4-48dc-af5d-f4f48034e1e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -134,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Icon_Grey',
      parent: '798026a3-fd4b-4f52-8954-14f41df2a205',
      stateByName: {
        'main-menu-max-lives': {
          texture: 'Heart_Icon_Grey'
        },
        'main-menu': {
          texture: 'Heart_Icon',
          scale: {
            x: 0.75,
            y: 0.75
          }
        }
      }
    },
    {
      id: 'f6f4004a-fca1-4969-a04e-d1a8cdea670d',
      type: 'Text',
      name: '',
      className: '',
      x: -89,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+1',
      localize: false,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#555555',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '798026a3-fd4b-4f52-8954-14f41df2a205',
      stateByName: {
        'main-menu': {
          style: {
            stroke: '#1f70f2'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'game',
    'main-menu',
    'main-menu-max-lives'
  ],
  handleResize: false
} as const;

export class OutOfLivesPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  background!: Sprite;
  header!: Sprite;
  closeButton!: Sprite & { data: typeof raw['list'][5]['data'] };
  buyLivesGroup!: Container;
  askForLivesGroup!: Container;
  bgHexagon!: Sprite;
  rays!: Sprite;
  bigHeart!: Sprite;
  livesCountdownText!: Text;
  title!: Text;
  livesButtonContainer!: Container & { data: typeof raw['list'][14]['data'] };
  askForLivesButton!: Container;
  buyLivesButton!: ButtonLargeLayout & { data: typeof raw['list'][16]['data'] };
  maxLivesButton!: ButtonLargeLayout & { data: typeof raw['list'][17]['data'] };
  buyLivesCoinAmountText!: Text;
  buyLivesAmountText!: Text;
  buyLivesMaxText!: Text;
  askFriendReadyGroup!: ButtonLargeLayout & { data: typeof raw['list'][24]['data'] };
  askFriendCooldownGroup!: ButtonLargeLayout & { data: typeof raw['list'][25]['data'] };
  askFriendCountdownText!: Text;
  StateName!: 'game' | 'main-menu' | 'main-menu-max-lives';

  constructor() {
    populate(this, raw);
  }
}
